<template>
  <div class="content-placeholder" :class="computedVariant" aria-describedby="content" tabindex="1">
    <Icon :name="`eenvandaag-general:${icon}`" class="icon" role="presentation" />
    <div class="content">
      <Heading :content="title" :level="2" class="title" />
      <Paragraph :content="text" class="description" />
    </div>
    <Button
      v-if="cookie"
      label="Wijzig cookies"
      variant="primary"
      original-icon
      @click="openCookieSettings"
    />
  </div>
</template>

<script setup lang="ts">
interface IProps {
  text?: string;
  title?: string;
  icon?: string;
  cookie?: boolean;
  variant: 'full-width' | 'narrow' | 'modal';
}

const props = withDefaults(defineProps<IProps>(), {
  text: 'Kan laatste items niet ophalen',
  title: 'Oeps',
  icon: 'warning',
  cookie: false,
  variant: 'full-width',
});

const openCookieSettings = () => {
  if (import.meta.client) {
    if (window && window.ccm) {
      window.ccm.showCookieMessage();
    }
  }
};

const computedVariant = computed(() => {
  return `is-${props.variant}`;
});
</script>

<style lang="postcss" scoped>
.content-placeholder {
  --content-placeholder-icon-size: calc(1rem / 16 * 84);
  --content-placeholder-padding: var(--unit-24) var(--unit-20) var(--unit-32) var(--unit-20);
  --content-placeholder-gap: var(--unit-16);
  --content-placeholder-content-gap: var(--unit-8);
  --content-placeholder-background: #f9f9fb;
  --content-placeholder-border: 1px solid hsl(var(--color-primary-100));

  @media (--lg-viewport) {
    --content-placeholder-icon-size: calc(1rem / 16 * 124);
    --content-placeholder-padding: var(--unit-32) var(--unit-80) var(--unit-40) var(--unit-80);
    --content-placeholder-gap: var(--unit-24);
    --content-placeholder-content-gap: var(--unit-12);
  }

  display: flex;
  gap: var(--content-placeholder-gap);
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: var(--content-placeholder-padding);
  border: var(--content-placeholder-border);
  background: var(--content-placeholder-background); /* this seems to be a unique color */

  &.is-narrow {
    max-width: calc(1rem / 16 * 500);
  }

  &.is-modal {
    --content-placeholder-background: hsl(var(--color-primary-950));
    --content-placeholder-border: none;

    &:deep(.title),
    &:deep(.description) {
      color: hsl(var(--color-neutral-white));
      text-align: left;
    }

    &:deep(.content) {
      width: 100%;
      align-items: flex-start;
    }
  }
}

.icon {
  width: var(--content-placeholder-icon-size);
  height: var(--content-placeholder-icon-size);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--content-placeholder-content-gap);
}

.title,
.description {
  text-align: center;
}

.title {
  @mixin title-lg {
  }
  color: hsl(var(--color-primary-900));
}

.description {
  @mixin body-sm {
  }
  color: hsl(var(--color-primary-600));
}
</style>
